<script>
  import Logo from './Logo.svelte';
  import MenuButton from './MenuButton.svelte';
</script>

<div class="container">
  <div class="logo-title">
    <Logo />
    <div class="same-column">
      <h1>CTB</h1>
      <h2>Capture Test Bench</h2>
    </div>
  </div>
  <MenuButton on:clickMenu />
</div>

<style>
  .container {
    display: flex;
    justify-content: space-between;
    color: #E7964B;
    height: 100%;
    gap: 5px;
  }
  .logo-title {
    display: flex;
  }
</style>